<template>
    <div class="md:tw-grid md:tw-grid-cols-3 md:tw-gap-4 tw-pb-3">
        <!-- Basics -->
        <div class="tw-text-center">
            <h3 class="tw-m-0 tw-block tw-text-lg tw-text-left">Basics</h3>

            <l-user-profile-edit-picture />
        </div>

        <l-user-profile-edit-basics-form class="md:tw-col-span-2" />
        <!-- /Basics -->

        <div
            class="md:tw-col-span-3 tw-my-4 tw-border-0 tw-border-b tw-border-solid tw-border-gray-100"
        ></div>

        <!-- Email -->
        <div>
            <h3 class="tw-m-0 tw-text-lg">Email</h3>
        </div>

        <div class="md:tw-col-span-2">
            <l-input-text
                id="email"
                label="Email"
                type="email"
                :value="currentUser.username"
                :disabled="true"
                :readonly="true"
                class="tw"
            />
        </div>
        <!-- /Email -->

        <div
            class="md:tw-col-span-3 tw-my-4 tw-border-0 tw-border-b tw-border-solid tw-border-gray-100"
        ></div>

        <!-- Password -->
        <div>
            <h3 class="tw-m-0 tw-text-lg">{{ $t("profile.edit.password") }}</h3>
        </div>

        <l-user-profile-edit-password-form class="md:tw-col-span-2" />
        <!-- /Password -->

        <div
            class="md:tw-col-span-3 tw-my-4 tw-border-0 tw-border-b tw-border-solid tw-border-gray-100"
        ></div>

        <!-- Language -->
        <div>
            <h3 class="tw-m-0 tw-text-lg">{{ $t("profile.edit.language") }}</h3>
        </div>

        <l-user-profile-edit-language-form class="md:tw-col-span-2" />
        <!-- /Language -->

        <div
            class="md:tw-col-span-3 tw-my-4 tw-border-0 tw-border-b tw-border-solid tw-border-gray-100"
        ></div>

        <!-- Notifications -->
        <div>
            <h3 class="tw-m-0 tw-text-lg">{{ $t("profile.edit.notifications") }}</h3>
        </div>

        <l-user-profile-edit-notifications-form class="md:tw-col-span-2" />
        <!-- /Notifications -->

        <div
            class="md:tw-col-span-3 tw-my-4 tw-border-0 tw-border-b tw-border-solid tw-border-gray-100"
        ></div>

        <!-- Calendar Integration -->
        <div>
            <h3 class="tw-m-0 tw-text-lg">{{ $t("profile.edit.calendar") }}</h3>
        </div>

        <l-user-profile-edit-calendar-integration-form class="md:tw-col-span-2" />
        <!-- /Calendar Integration -->

        <div
            class="md:tw-col-span-3 tw-my-4 tw-border-0 tw-border-b tw-border-solid tw-border-gray-100"
        ></div>

        <!-- Meeting Export -->
        <div>
            <h3 class="tw-m-0 tw-text-lg">{{ $t("profile.edit.exportCheckins") }}</h3>
        </div>

        <l-user-profile-edit-meeting-export-form class="md:tw-col-span-2" />
        <!-- /Meeting Export -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LInputText from "@/components/LInputText";
import LUserProfileEditBasicsForm from "@/components/LUserProfileEdit/LUserProfileEditBasicsForm";
import LUserProfileEditPicture from "@/components/LUserProfileEdit/LUserProfileEditPicture";
import LUserProfileEditPasswordForm from "@/components/LUserProfileEdit/LUserProfileEditPasswordForm";
import LUserProfileEditLanguageForm from "@/components/LUserProfileEdit/LUserProfileEditLanguageForm";
import LUserProfileEditNotificationsForm from "@/components/LUserProfileEdit/LUserProfileEditNotificationsForm";
import LUserProfileEditMeetingExportForm from "@/components/LUserProfileEdit/LUserProfileEditMeetingExportForm";
import LUserProfileEditCalendarIntegrationForm from "@/components/LUserProfileEdit/LUserProfileEditCalendarIntegrationForm";

export default {
    components: {
        LInputText,
        LUserProfileEditBasicsForm,
        LUserProfileEditPicture,
        LUserProfileEditPasswordForm,
        LUserProfileEditLanguageForm,
        LUserProfileEditNotificationsForm,
        LUserProfileEditMeetingExportForm,
        LUserProfileEditCalendarIntegrationForm,
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
            rights: "users/current/rights",
        }),
    },
    beforeCreate() {
        this.$emit("title", this.$t("profile.edit.title"));
    },
};
</script>
